import React from 'react'
import Testing from 'src/modules/ETesting/Testing'

const TestingPage = () => {
  return <Testing />
}
export default TestingPage
